import { NgIf } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  Inject,
  signal,
} from "@angular/core";
import { ChatOpenStore } from "app/chat";
import { APP_CONFIG, AppConfig, AppHostService } from "app/core";
import { DragDropDirective, IconButtonComponent } from "app/core/ui";

@Component({
  selector: "fof-reduced-bot",
  templateUrl: "./template.html",
  standalone: true,
  imports: [NgIf, IconButtonComponent, DragDropDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**Component displayed when bot is reduced*/
export class ReducedBotComponent {
  protected src: string;
  protected hasBubble = false;

  private readonly _bubbleClosedByUser = signal(false);

  protected showBubble = computed(
    () =>
      this.hasBubble &&
      !this.host.isMobile &&
      !this.host.isSmallScreen() &&
      !this._bubbleClosedByUser()
  );

  @HostBinding("style") hostStyles = `font-size: var(--fof-reduced-bot-font-size);`;
  @HostBinding("class") hostClasses =
    "h-100 d-flex flex-column align-items-end justify-content-end border-0 bg-transparent p-2";

  protected readonly isDragDropEnabled: boolean;

  constructor(
    @Inject(APP_CONFIG) config: AppConfig,
    private readonly chatOpenStore: ChatOpenStore,
    protected readonly host: AppHostService
  ) {
    this.src = config.distLocation + config.reducedBotLogoUrl;
    this.hasBubble = config.reducedBotHasWelcomeText;
    this.isDragDropEnabled = config.isDragDropEnabled ?? false;
  }

  public openChat(): void {
    this.chatOpenStore.open();
  }

  public closeBubble(event: Event): void {
    event.preventDefault();
    this._bubbleClosedByUser.set(true);
  }
}
